export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sitio"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID de tienda"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de tienda"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enlace de pago"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activo"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No activo"])}
}